import { useEffect } from 'react';
import { Spin, Skeleton } from 'antd';
import SelectedViewBadge from '../content/selectedViewBadge';
import EditorCard from '../content/editorCard';
import PageTreeActions from './pagetreeactions';
import PageView from './pageview';
import { TreeNode } from '../../types/types';

interface PageContentPanelProps {
    selectedKey: string | null;
    selectedView: 'editor' | 'pageview' | null;
    selectedPageName: string;
    loadingInitial: boolean;
    loadingPageDetails: boolean;
    newNodeTitle: string;
    setNewNodeTitle: (title: string) => void;
    handleAddNode: () => void;
    content: React.ReactNode;
    isEditable: boolean;
    data: TreeNode[];
}

const PageContentPanel: React.FC<PageContentPanelProps> = ({
    selectedKey,
    selectedView,
    selectedPageName,
    loadingInitial,
    loadingPageDetails,
    newNodeTitle,
    setNewNodeTitle,
    handleAddNode,
    content,
    isEditable,
    data,
}) => {

    useEffect(() => {
        setNewNodeTitle('');
    }, [selectedKey, setNewNodeTitle]);

    return (
        <div style={{ padding: '15px 20px 0px 20px', flex: 1, overflowY: 'auto' }}>
            {selectedKey && (
                <SelectedViewBadge
                    selectedView={selectedView === 'editor' ? undefined : selectedView}
                    pageName={selectedPageName}
                />
            )}
            {loadingInitial ? (
                <Skeleton active paragraph={{ rows: 10 }} style={{ padding: '16px' }} />
            ) : (
                <>
                    {selectedKey && selectedView === 'editor' && (
                        <Spin spinning={loadingPageDetails} style={{ width: '100%' }}>
                            <EditorCard title={selectedPageName}>
                                <PageTreeActions
                                    newNodeTitle={newNodeTitle}
                                    setNewNodeTitle={setNewNodeTitle}
                                    addNode={handleAddNode}
                                    content={content}
                                    isEditable={isEditable}
                                />
                            </EditorCard>
                        </Spin>
                    )}
                    {selectedKey && selectedView === 'pageview' && (
                        <PageView pageTreeData={data} selectedKey={selectedKey} />
                    )}
                </>
            )}
        </div>
    );
};

export default PageContentPanel;